import { isPlatformBrowser } from '@angular/common';
import { Component, OnInit, Input, Inject, DOCUMENT, PLATFORM_ID } from '@angular/core';
import { GlobalService } from 'src/_service/GlobalService';


@Component({
  selector: 'app-cms-script',
  templateUrl: './cms-script.component.html',
  standalone: true
})
export class CmsScriptComponent implements OnInit {

  @Input() script: any;


  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject(DOCUMENT) private document,
    private _globalService: GlobalService,
  ) {

  }


  ngOnInit() {
    let node = this.document.createElement('script');
    let appendTo;
    if (this.script.inline) {
      appendTo = this.document.getElementsByClassName('cms-script-content')[0];
    } else {
      appendTo = this.document.getElementsByTagName('body')[0];
    }

    this.script?.id ? node.id = this.script.id : null;
    node.src = this.script.src;
    node.type = this.script.type;
    node.async = this.script.async;
    node.dataset['culture'] = this._globalService.getLanguage()

    if (!this.script.inline || this.script.inline && isPlatformBrowser(this.platformId))
      appendTo.appendChild(node);
  }

}



